import { track } from '@mc/track-event'

export const trackClick = ({ query, index, ...restProps }) => {
  track('Search Result Clicked', {
    search: query,
    search_results_index: index,
    ...restProps,
  })
}
